import React, { useEffect } from "react";
import { useDispatchWrapper } from "../../../hooks";
import { useFormik } from "formik";
import { Dialog } from "../../../components/Dialogs/Dialog";
import { Grid } from "@mui/material";
import {
	ControlledCustomSelect,
	CustomFormLabel,
	CustomTextField,
} from "../../../components/formsComponents";
import { renderDropdownValue } from "../../../helpers";
import LoadingDialog from "../../../components/Dialogs/LoadingDialog";
import { upsertSecurityRoleGroupAsync } from "../../../redux/security/role-group/role-group.actions";
import { ISecurityRoleGroup } from "../../../redux/security/role-group/role-group.types";

interface IManageRoleGroupDialogProps {
	open: boolean;
	onClose: () => void;
	roleGroup: ISecurityRoleGroup;
}
export const ManageRoleGroupDialog: React.FC<IManageRoleGroupDialogProps> = (
	props
) => {
	const { open, roleGroup, onClose } = props;

	const [saveLoading, setSaveLoading] = React.useState(false);

	const dispatch = useDispatchWrapper();
	const {
		values,
		errors,
		setValues,
		handleChange,
		handleSubmit,
		setFieldValue,
	} = useFormik({
		initialValues: roleGroup,
		validate: (values) => {
			const errors: any = {};
			if (!values.role_group) {
				errors.role_group = "*This field is required.";
			}
			return errors;
		},
		onSubmit: async (values) => {
			setSaveLoading(true);
			dispatch(
				upsertSecurityRoleGroupAsync(values, (isSuccess) => {
					if (isSuccess) {
						onClose();
					}
					setSaveLoading(false);
				})
			);
		},
	});

	// useEffect(() => {
	//     if (!roleGroup) return;
	//     setValues(roleGroup)
	// }, [roleGroup])

	return (
		<Dialog
			open={open}
			title="Add/Edit Role Group"
			onClose={onClose}
			size="md"
			contentWrappedWithForm={{ onSubmit: handleSubmit }}
			actions={[
				{ type: "button", label: "Close", variant: "text", onClick: onClose },
				{
					type: "submit",
					label: "Save",
					variant: "contained",
					disabled: saveLoading,
				},
			]}
		>
			<Grid
				container
				spacing={1}
			>
				<LoadingDialog open={saveLoading} />
				<Grid
					item
					xs={12}
					lg={6}
				>
					<CustomFormLabel>Role Group</CustomFormLabel>
					<CustomTextField
						name="role_group"
						variant="outlined"
						size="small"
						fullWidth
						value={values.role_group}
						error={errors.role_group ? true : false}
						helperText={errors.role_group}
						onChange={handleChange}
					/>
				</Grid>
				{values.role_group_uuid && (
					<Grid
						item
						xs={12}
						lg={6}
					>
						<CustomFormLabel>Status</CustomFormLabel>
						<ControlledCustomSelect
							variant="outlined"
							size="small"
							type="string"
							name="status"
							fullWidth
							value={values.status}
							onChange={handleChange}
							displayEmpty
							placeholder="Select one"
							renderValue={renderDropdownValue(`Select One`)}
							options={[
								{ label: "Active", value: "ACTIVE" },
								{ label: "Inactive", value: "INACTIVE" },
							]}
						/>
					</Grid>
				)}
			</Grid>
		</Dialog>
	);
};
